// extracted by mini-css-extract-plugin
export default {"overlay":"_1XfXt28h0tHUpM3FnFztA1"};